
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Источник данных',
	'dataSourceId': 'ID',
	'dataSourceType': 'Ввести',
	'dataSourceName': 'Имя',
	'dataSourcePath': 'Путь',
	'showInfoForAll': 'Показывать длительность для всех визуализаций',
	'hideInfoForAll': 'Скрыть длительность для всех визуализаций',
	'showPerformanceDetails': 'Повторно запустить все виджеты, чтобы включить сведения о производительности',
	'slotMappingField': 'Отображения слотов',
	'slotDataMapping': 'Отображение',
	'slotID': 'ID',
	'slotCaption': 'Заголовок',
	'slotMandatory': 'Обязательный',
	'slotIsMandatory': 'Да',
	'slotIsNotMandatory': 'Нет',
	'infoNotAvailable': 'Недоступно',
	'performanceSection': 'Производительность',
	'durationField': 'Длительность',
	'singleQueryTime': 'Запрос сервера (мс)',
	'multipleQueryTime': 'Запрос сервера %{name} (мс)',
	'liveWidgetTotalTime': 'Всего (мс)',
	'renderTimeNotAvailable': 'Не имеется',
	'renderInProgress': '(выполняется)',
	'interactToTriggerQuery': 'Взаимодействие с виджетом, чтобы инициировать запрос',
	'fetchQuery': 'Извлечь запрос',
	'showSQLMDX': 'Показывать SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Информация о запросе',
	'queryInfoNotAvailable': 'Информация о запросе недоступна',
	'query': 'Запрос',
	'copy': 'Копировать',
	'close': 'Закрыть'
});
